import { ubicationTypeEnum } from '../../utils/dataStatus';

export const checkIfLocationTypeGeneric = (values) =>
  values.ubication.ubicationType?.id === ubicationTypeEnum.genericaOverhead ||
  values.ubication.ubicationType?.id === ubicationTypeEnum.genericaProyecto;

export const shouldShowTypeObjectLocation = (values) =>
  !!(
    values.ubication?.ubicationType?.id === ubicationTypeEnum.locacion &&
    values.ubication?.typeEvent?.id &&
    values.ubication?.uunn &&
    values.ubication?.ubication
  );

export const shouldShowTypeObjectPozo = (values) =>
  !!(
    values.ubication?.ubicationType?.id === ubicationTypeEnum.pozo &&
    values.ubication?.uunn &&
    values.ubication?.ubication &&
    values.ubication?.event &&
    values.ubication?.team
  );

export const shouldShowTypeObjectOyMWithoutDuct = (values) =>
  values.isOyM &&
  values.ubication?.ubicationType?.id !== ubicationTypeEnum.ducto &&
  values.ubication?.uunn &&
  values.ubication?.ubication;

export const shouldShowTypeObjectDuct = (values) =>
  values.ubication?.ubicationType?.id === ubicationTypeEnum.ducto &&
  values.ubication?.uunn &&
  values.ubication?.ubication &&
  values.ubication?.installation;

export const shouldShowTypeObjectEnergy = (values) =>
  values.ubication?.ubicationType?.id === ubicationTypeEnum.energia &&
  values.ubication?.uunn &&
  values.ubication?.ubication &&
  values.ubication?.installation;

export const shouldShowTypeObjectGeneric = (values) =>
  (values.ubication?.ubicationType?.id === ubicationTypeEnum.genericaOverhead ||
    values.ubication?.ubicationType?.id === ubicationTypeEnum.genericaProyecto) &&
  values.ubication?.uunn &&
  values.ubication?.classification &&
  values.ubication?.ubication;
